<template>
  <div class="mod-config">
    <div class="bathbox">
      <p class="toplist">
        <span style="font-size: 20px;float: left;">批量新增</span>
        <el-button type="primary" @click="channelTemplate()" style="float: right;"
          v-if="isAuth('channelTemplate:view')">通道模板</el-button>
        <el-button type="primary" @click="newTemplate()" v-if="isAuth('channelTemplate:save')"
          style="float: right;margin-right: 10px;">新建模板</el-button>
      </p>

      <el-form :model="dataForm" :rules="dataRule" ref="dataForm">
        <!-- 模板一 -->
        <div style="height: 140px;">
          <el-table :data="dataForm.tableData" stripe style="width: 100%;top: 10px;"
            :header-cell-style="{ background: '#5EA1F9' }">
            <el-table-column label="设备数量" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'tableData.' + scope.$index + '.number'" :rules="dataRule.number">
                  <el-input v-model="scope.row.number" placeholder="设备数量" show-word-limit></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="设备名称前缀" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'tableData.' + scope.$index + '.deviceNamePrefix'"
                  :rules="dataRule.deviceNamePrefix">
                  <el-input v-model="scope.row.deviceNamePrefix" placeholder="设备名称前缀"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="唯一编码前缀" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'tableData.' + scope.$index + '.uniqueCodePrefix'"
                  :rules="dataRule.uniqueCodePrefix">
                  <el-input v-model="scope.row.uniqueCodePrefix" placeholder="唯一编码前缀"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="点位" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'tableData.' + scope.$index + '.poiId'" :rules="dataRule.poiId">
                  <el-select v-model="scope.row.poiId" filterable placeholder="请选择点位" style="width: 100%">
                    <el-option v-for="item in poiOption" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="设备状态" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'tableData.' + scope.$index + '.status'" :rules="dataRule.status">
                  <el-select v-model="scope.row.status" placeholder="请选择" style="width: 100%">
                    <el-option v-for="item in enumOption" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="设备类型" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'tableData.' + scope.$index + '.deviceType'" :rules="dataRule.deviceType">
                  <el-select v-model="scope.row.deviceType">
                    <el-option label="固定式" :value="0"></el-option>
                    <el-option label="便携式" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="质保截止日期" align="center" width="220">
              <template slot-scope="scope">
                <el-form-item :prop="'tableData.' + scope.$index + '.warrantyTime'" :rules="dataRule.warrantyTime">
                  <el-date-picker v-model="scope.row.warrantyTime" type="date" format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;">
                  </el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="开启通知" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'tableData.' + scope.$index + '.noticeEnable'" :rules="dataRule.noticeEnable">
                  <el-select v-model="scope.row.noticeEnable">
                    <el-option label="否" :value="0"></el-option>
                    <el-option label="是" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="开启上级推送" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'tableData.' + scope.$index + '.pushParent'">
                  <el-select v-model="scope.row.pushParent">
                    <el-option label="否" :value="0"></el-option>
                    <el-option label="是" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 模板二 -->
        <div class="mubaner">
          <label style="float: left;line-height: 40px;padding-right: 10px;">通道模板</label>
          <el-select v-model="dataForm.formname" @change="getCityOption" value-key="id" placeholder="请选择"
            style="float: left;width: 200px;">
            <el-option v-for="item in channelption" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
          <hr style="display: inline-block;width: 100%;height: 2px;">
          <el-table :data="dataForm.deviceList" stripe style="width: 100%;height: auto;max-height: 480px;"
            :header-cell-style="{ background: '#5EA1F9' }">
            <el-table-column align="center" label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="text" @click="deleteRowtable(scope.row, scope.$index)">删除</el-button>
              </template>
            </el-table-column>
            <el-table-column label="因子编码" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'deviceList.' + scope.$index + '.code'" :rules="dataRule.code">
                  <el-input v-model="scope.row.code" placeholder="因子编码" show-word-limit></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="因子名称" align="center" width="230">
              <template slot-scope="scope">
                <el-form-item :prop="'deviceList.' + scope.$index + '.name'" :rules="dataRule.name">
                  <el-input v-model="scope.row.name" placeholder="因子名称"></el-input>
                  <div style="position: absolute;top: 0;right: 0px;">
                    <el-dropdown placement="bottom" trigger="click" @visible-change="changeDrop(scope.$index)"
                      @command="clickDropdown($event, scope.row, scope.$index)">
                      <el-button>插入下标</el-button>
                      <el-dropdown-menu slot="dropdown" style="margin-top:4px;width: 110px;text-align: center;">
                        <el-dropdown-item command="₀">₀</el-dropdown-item>
                        <el-dropdown-item command="₁">₁</el-dropdown-item>
                        <el-dropdown-item command="₂">₂</el-dropdown-item>
                        <el-dropdown-item command="₃">₃</el-dropdown-item>
                        <el-dropdown-item command="₄">₄</el-dropdown-item>
                        <el-dropdown-item command="₅">₅</el-dropdown-item>
                        <el-dropdown-item command="₆">₆</el-dropdown-item>
                        <el-dropdown-item command="₇">₇</el-dropdown-item>
                        <el-dropdown-item command="₈">₈</el-dropdown-item>
                        <el-dropdown-item command="₉">₉</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="监测排序" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'deviceList.' + scope.$index + '.sort'" :rules="dataRule.sort">
                  <el-input v-model="scope.row.sort" placeholder="因子单位"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="因子单位" align="center" width="230">
              <template slot-scope="scope">
                <el-form-item :prop="'deviceList.' + scope.$index + '.unit'" :rules="dataRule.unit">
                  <el-input v-model="scope.row.unit" placeholder="因子单位"></el-input>
                  <div style="position: absolute;top: 0;right: 0px;">
                    <el-dropdown placement="bottom" trigger="click"
                      @command="clickDropdownunit($event, scope.row, scope.$index)">
                      <el-button>插入上标</el-button>
                      <el-dropdown-menu slot="dropdown" style="margin-top:4px;width: 110px;text-align: center;">
                        <el-dropdown-item command="⁰">⁰</el-dropdown-item>
                        <el-dropdown-item command="¹">¹</el-dropdown-item>
                        <el-dropdown-item command="²">²</el-dropdown-item>
                        <el-dropdown-item command="³">³</el-dropdown-item>
                        <el-dropdown-item command="⁴">⁴</el-dropdown-item>
                        <el-dropdown-item command="⁵">⁵</el-dropdown-item>
                        <el-dropdown-item command="⁶">⁶</el-dropdown-item>
                        <el-dropdown-item command="⁷">⁷</el-dropdown-item>
                        <el-dropdown-item command="⁸">⁸</el-dropdown-item>
                        <el-dropdown-item command="⁹">⁹</el-dropdown-item>
                        <el-dropdown-item command="ⁿ">ⁿ</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="因子类型" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'deviceList.' + scope.$index + '.type'" :rules="dataRule.type">
                  <el-select v-model="scope.row.type">
                    <el-option label="监测值" :value="0"></el-option>
                    <el-option label="计算值" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="报警模式" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'deviceList.' + scope.$index + '.alarmType'" :rules="dataRule.alarmType">
                  <el-select v-model="scope.row.alarmType">
                    <el-option label="高报模式" :value="0"></el-option>
                    <el-option label="低报模式" :value="1"></el-option>
                    <el-option label="区间报警模式" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="一级预警值" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'deviceList.' + scope.$index + '.firstAlarmValue'"
                  :rules="dataRule.firstAlarmValue">
                  <el-input v-model="scope.row.firstAlarmValue" show-word-limit placeholder="一级预警值"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="二级预警值" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'deviceList.' + scope.$index + '.secondAlarmValue'"
                  :rules="dataRule.secondAlarmValue">
                  <el-input v-model="scope.row.secondAlarmValue" show-word-limit placeholder="二级预警值"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;margin-top: 10px;">
            <i class="el-icon-circle-plus-outline" style="font-size: 30px;cursor: pointer" @click="addRowtable"></i>
          </div>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footeruser">
      <el-button type="primary" @click="saveGet">确定</el-button>
      &nbsp;&nbsp;
      <router-link to="/indexhome/device" replace>
        <el-button type="danger">取消</el-button>
      </router-link>
    </span>


    <!-- 弹窗, 通道模板 -->
    <el-dialog title="通道模板" :visible.sync="theclaimEquipment" :modal-append-to-body="false" :show-close="true"
      :close-on-click-modal="false" :append-to-body="true" width="700px">
      <el-form :inline="true" style="display: inline-block;width: 100%;padding-top: 10px;" v-model="dataFormrl">
        <el-form-item label="模板名称">
          <el-input v-model="dataFormrl.name" placeholder="模板名称" clearable></el-input>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="channelTemplate()"></el-button>
        <div style="float: right;margin-bottom: 10px;">
          <el-button type="danger" :disabled="recycleSelections.length <= 0" @click="templateDelete()"
            v-if="isAuth('channelTemplate:delete')">批量删除</el-button>
        </div>
      </el-form>
      <el-table :data="deviceOptionrl" style="width: 100%" height="310" border stripe tooltip-effect="dark"
        @selection-change="recycleChangeHandle">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="name" label="模板名称" align="center">
        </el-table-column>
        <el-table-column prop="address" label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="编辑" placement="top">
              <i class="el-icon-edit-outline" style="font-size: 24px;cursor: pointer;" @click="edit(scope.row)"
                v-if="isAuth('channelTemplate:update')"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top">
              <i class="el-icon-delete-solid" style="font-size: 24px;cursor: pointer;"
                @click="templateDelete(scope.row)" v-if="isAuth('channelTemplate:delete')"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="sizeChangeHandle_claim" @current-change="currentChangeHandle_claim"
        :page-size="pageSize_claim" :total="totalPage" :current-page="pageIndex_claim" :page-sizes="[20, 50, 100]"
        layout="prev, pager, next, jumper, total,sizes">
      </el-pagination>
    </el-dialog>

    <!-- 修改通道模板 -->
    <add-or-update v-if="editVisible" ref="addOrUpdate" @refreshDataList="channelTemplate"></add-or-update>

    <!-- <el-dialog title="编辑" :visible.sync="editVisible" :modal-append-to-body="false" :show-close="true"
      :close-on-click-modal="false" :append-to-body="true" class="editbatch" width="100%">
    </el-dialog> -->
  </div>
</template> 

<script>  
import { isAuth } from "@/utils";
import AddOrUpdate from './edit-add-or-update'
let ids, dispatchId;
export default {
  name: 'batchAddition',
  data() {
    return {
      editVisible:false,
      dataForm: {
        tableData: [{
          number: '',
          deviceNamePrefix: '',
          uniqueCodePrefix: '',
          poiId: '',
          status: '',
          deviceType: 0,
          warrantyTime: '',
          pushParent:0,
          noticeEnable: 1,
        }],

        deviceList: [{
          code: '',
          name: '',
          sort: '',
          unit: '',
          type: 0,
          alarmType: 0,
          firstAlarmValue: '',
          secondAlarmValue: '',
        }],
      },
      //验证规则
      dataRule: {
        number: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        deviceNamePrefix: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        uniqueCodePrefix: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        poiId: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        status: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        deviceType: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        warrantyTime: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        noticeEnable: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        code: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        name: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        sort: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        unit: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        type: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        alarmType: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        firstAlarmValue: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
        secondAlarmValue: [
          { required: true, message: '', trigger: ['blur', 'change'] }
        ],
      },
      poiOption: [],
      enumOption: [],
      channelption: [],
      theclaimEquipment: false,
      batchClaimVisible: false,
      recycleSelections: [],
      deviceOptionrl: [],
      dataFormrl: {
        name: '',
      },
      pageIndex_claim: 1,
      pageSize_claim: 10,
      totalPage: 0,
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
    this.getPoiOption();
    this.getDeviceStatusOption();
    this.getDataList();
  },
  methods: {
    getDataList() {
      this.$http({
        url: this.$http.adornUrl("ChannelTemplate/list"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.channelption = data.data.rows
        }
      })
    },
    //获取设备状态
    getDeviceStatusOption() {
      this.$http({
        url: this.$http.adornUrl("configOption/option/2"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.enumOption = data.data.enumOption
        }
      })
    },
    //获取点位
    getPoiOption() {
      this.$http({
        url: this.$http.adornUrl("poi/option"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.poiOption = data.data.poiOption
        }
      })
    },
    // 编辑
    edit(val){
      // console.log(val)
      this.editVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(val)
      })
    },
    // 删除&&批量删除
    templateDelete(id) {
      if (id) {
        ids = id.name ? [id.name] : this.recycleSelections.map(item => {
          return item.name
        })
        dispatchId = id.id ? [id.id] : this.recycleSelections.map(item => {
          return item.id
        })
      } else {
        ids = id ? [id] : this.recycleSelections.map(item => {
          return item.name
        })
        dispatchId = id ? [id] : this.recycleSelections.map(item => {
          return item.id
        })
      }
      this.$confirm(`确定对[设备：${ids.join(',')}]进行[${ids ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl("ChannelTemplate/delete"),
          method: 'post',
          data: this.$http.adornData(dispatchId, false)
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
            this.channelTemplate()
            this.getDataList();
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    channelTemplate() {
      this.theclaimEquipment = true;
      this.$http({
        url: this.$http.adornUrl("ChannelTemplate/list"),
        method: 'get',
        params: this.$http.adornParams({
          'pageNum': this.pageIndex_claim,
          'pageSize': this.pageSize_claim,
          'name': this.dataFormrl.name
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.deviceOptionrl = data.data.rows
          this.totalPage = data.data.total
        } else {
          this.deviceOptionrl = []
          this.totalPage = 0
          this.$message.error(data.msg);
        }
      })
    },
    // 新建模板
    newTemplate() {
      this.$router.replace({ path: '/indexhome/batchAdd/deviceIndex' });
    },
    recycleChangeHandle(val) {
      this.recycleSelections = val;
    },
    /** 
     * 模板二 
     */
    clickDropdown(item, row, index) {
      row.name = row.name + item
    },
    clickDropdownunit(item, row, index) {
      row.unit = row.unit + item
    },
    deleteRowtable(row, index) {
      this.dataForm.deviceList.splice(index, 1);
    },
    addRowtable() {
      var item = {
        code: '',
        name: '',
        sort: '',
        unit: '',
        type: 0,
        alarmType: 0,
        firstAlarmValue: '',
        secondAlarmValue: '',
      }
      this.dataForm.deviceList.push(item)
    },
    getCityOption(val) {
      this.$http({
        url: this.$http.adornUrl("ChannelTemplate/list"),
        method: 'get',
        params: this.$http.adornParams({
          'id': val.id
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.dataForm.deviceList = data.data.rows[0].templateDataList
        }
      })
    },
    /**
     * 认领分页
     * @param {*} val 
     */
    sizeChangeHandle_claim(val) {
      this.pageSize_claim = val;
      this.pageIndex_claim = 1;
      this.channelTemplate();
    },
    // 当前页
    currentChangeHandle_claim(val) {
      this.pageIndex_claim = val;
      this.channelTemplate();
    },
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    saveGet() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl('device/addBatchDevice'),
            method: 'post',
            data: this.$http.adornData({
              "number": this.dataForm.tableData[0].number,
              "deviceNamePrefix": this.dataForm.tableData[0].deviceNamePrefix,
              "uniqueCodePrefix": this.dataForm.tableData[0].uniqueCodePrefix,
              "poiId": this.dataForm.tableData[0].poiId,
              "status": this.dataForm.tableData[0].status,
              "deviceType": this.dataForm.tableData[0].deviceType,
              "warrantyTime": this.dataForm.tableData[0].warrantyTime,
              "noticeEnable": this.dataForm.tableData[0].noticeEnable,
              "pushParent": this.dataForm.tableData[0].pushParent,
              "channelList": this.dataForm.deviceList
            })
          }).then(({ data }) => {
            if (data && data.code === 200) {
              this.$message({
                message: data.msg,
                type: 'success',
                duration: 1000,
              })
              this.$router.replace({ path: '/indexhome/device' });
            } else {
              this.$message.error(data.msg);
            }
          })
        }
      })
    },
    //权限
    isAuth(key) {
      return isAuth(key)
    },
  }
}
</script>

<style>
.bathbox .toplist {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #bbb;
}

.mod-config {
  position: relative;
}

.dialog-footeruser {
  display: flex;
  bottom: 0px;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  border-top: 2px solid #bbb;
  height: 60px;
}

.bathbox .el-form-item {
  margin-bottom: 0
}

.bathbox .el-table td,
.bathbox .el-table th.is-leaf {
  border-right: none !important
}

.bathbox .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: initial;
}

.bathbox .mubaner .el-table__body-wrapper {
  max-height: 400px;
  overflow-y: scroll;
  padding-bottom: 10px;
}
.editbatch .el-dialog {
  height: calc(100% - 100px);
}
</style>


// WEBPACK FOOTER //
// src/pages/admincenter/batchAdd/batchAddition.vue